/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateResellerInvoiceOverviews200ResponseResellersInner
 */
export interface CreateResellerInvoiceOverviews200ResponseResellersInner {
    /**
     * 
     */
    resellerName?: string;
    /**
     * 
     */
    spCount?: number;
    /**
     * 
     */
    monitoringClients?: number;
    /**
     * 
     */
    newAuditClients?: number;
}

/**
 * Check if a given object implements the CreateResellerInvoiceOverviews200ResponseResellersInner interface.
 */
export function instanceOfCreateResellerInvoiceOverviews200ResponseResellersInner(value: object): value is CreateResellerInvoiceOverviews200ResponseResellersInner {
    return true;
}

export function CreateResellerInvoiceOverviews200ResponseResellersInnerFromJSON(json: any): CreateResellerInvoiceOverviews200ResponseResellersInner {
    return CreateResellerInvoiceOverviews200ResponseResellersInnerFromJSONTyped(json, false);
}

export function CreateResellerInvoiceOverviews200ResponseResellersInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateResellerInvoiceOverviews200ResponseResellersInner {
    if (json == null) {
        return json;
    }
    return {
        
        'resellerName': json['resellerName'] == null ? undefined : json['resellerName'],
        'spCount': json['spCount'] == null ? undefined : json['spCount'],
        'monitoringClients': json['monitoringClients'] == null ? undefined : json['monitoringClients'],
        'newAuditClients': json['newAuditClients'] == null ? undefined : json['newAuditClients'],
    };
}

export function CreateResellerInvoiceOverviews200ResponseResellersInnerToJSON(json: any): CreateResellerInvoiceOverviews200ResponseResellersInner {
    return CreateResellerInvoiceOverviews200ResponseResellersInnerToJSONTyped(json, false);
}

export function CreateResellerInvoiceOverviews200ResponseResellersInnerToJSONTyped(value?: CreateResellerInvoiceOverviews200ResponseResellersInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'resellerName': value['resellerName'],
        'spCount': value['spCount'],
        'monitoringClients': value['monitoringClients'],
        'newAuditClients': value['newAuditClients'],
    };
}

